import { ROUTER_PATHS } from '@constants/router';

import { HeaderItem } from '../types';

type HeaderActionsFunctions = {
  logout: () => void;
};

export const buildHeaderActions = ({ logout }: HeaderActionsFunctions): HeaderItem[] => [
  {
    href: ROUTER_PATHS.DEVELOPER_HOME,
    messageId: 'pages.APP_HOME.title',
  },
  {
    href: ROUTER_PATHS.PROFILE,
    messageId: 'pages.PROFILE.title',
  },
  {
    href: ROUTER_PATHS.TEAMMATES,
    messageId: 'pages.TEAMMATES.title',
  },
  {
    href: ROUTER_PATHS.APPS,
    messageId: 'pages.APPLICATIONS.title',
  },
  {
    href: ROUTER_PATHS.WIDGETS,
    messageId: 'pages.WIDGETS.title',
  },
  {
    href: ROUTER_PATHS.TESTS,
    messageId: 'pages.TESTS.title',
  },
  {
    onClick: logout,
    messageId: 'exit',
  },
];
